import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1448693e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1448693e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1448693e')) {
      api.createRecord('1448693e', component.options)
    } else {
      api.reload('1448693e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1448693e&scoped=true", function () {
      api.rerender('1448693e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/index.vue"
export default component.exports